import APIClient from '@/shared/http/clients/api'

const resourceName = 'gedPastaHistorico'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetAll = (folderID, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/pasta/${folderID}`, data, config)

const GedFolderHistoryRepository = {
  GetAll
}

export default GedFolderHistoryRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/gedfolderhistory.js